// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tabs-slider-wrapper[data-v-fe07e5ba]{top:0}.v-picker__title[data-v-fe07e5ba]{height:90px}.v-time-picker-title__time *[data-v-fe07e5ba]{font-size:60px;height:60px}.v-picker__body[data-v-fe07e5ba]{height:290px}.v-tabs-items[data-v-fe07e5ba]{height:380px}.v-tab--active .v-icon[data-v-fe07e5ba]{color:#fff}", ""]);
// Exports
module.exports = exports;
